import { ReactNode } from "react"
import cn from "classnames"

interface SubmenuProps {
    children: ReactNode
    hidden?: boolean
}

export function Submenu({ children, hidden }: SubmenuProps) {
    return (
        <div
            className={cn("mobile-navigation__submenu", {
                "mobile-navigation__submenu-hidden": hidden,
            })}
        >
            {children}
        </div>
    )
}
